export default {
    methods: {
        ttt(){
            // console.log(this.)
        },
        fanhui() {
            this.getactivities();
            this.itemname = ''
            this.ziyuan = []
            this.show1 = 'display:block'
            this.show2 = 'display:none'
        },

        handleSizeChange(id) {
            this.length = id;
            this.getactivities();
        },
        handleCurrentChange(id) {
            this.offset = (id - 1) * this.length;
            this.currentPage = id;
            this.getactivities();
        },

        xiugaiziyuan(id, index) {
            if (id == 1) {
                this.xiugaijieziyuan = true
                this.jieziyuan.name = this.ziyuan[index].name
                this.jieziyuan.data = this.ziyuan[index].data
               
                this.ziyuanindex = index
                // console.log('this.huodongtype',this.huodongtype)
            }
            if (id == 2) {
                this.$confirm('此操作将删除该活动, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let ziyuan = this.ziyuan
                    ziyuan.splice(index, 1)
                    this.ziyuan = ziyuan

                    let itemname = this.itemname
                    let arr = this.data
                    for (let i = 0; i < arr.length; i++) {
                        for (let j = 0; j < arr[i].children.length; j++) {

                            if (arr[i].children[j].label == itemname) {
                                // console.log(arr[i].children[j].resources[this.ziyuanindex])
                                arr[i].children[j].resources.splice(index, 1)
                            }
                        }
                    }

                    let resources = []
                    for (let val of arr) {
                        let items = []
                        for (let i = 0; i < val.children.length; i++) {
                            items.push({
                                name: val.children[i].label,
                                resources: val.children[i].resources
                            })
                        }
                        resources.push({
                            name: val.label,
                            items: items
                        })
                    }


                    let date = {
                        token: this.$store.state.authority_management,
                        resources: JSON.stringify(resources),
                        id: this.arr.id
                    }

                    this.$post('activities/shop_edit', date).then(res => {
                        // console.log(res)
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        })
                    })

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            }
        },
        changtype(type) {
            this.jieziyuan.get = ''
            let arr = this.type
            let i = arr.indexOf(type) + 1
            this.typeid = i
            this.ziyuanliebiao = []
            // console.log(this.typeid)
            // console.log('------')
        },
        changziyuan(name) {
            this.jieziyuan.name = name
            let arr = this.ziyuanliebiao
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].name == name) {
                    this.jieziyuan.data = this.ziyuanliebiao[i].data
                    this.jieziyuan.id = this.ziyuanliebiao[i].id
                }
            }
        },
        changziyuans(name) {
            this.tianjiaziyuan.name = name
            let arr = this.ziyuanliebiao
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].name == name) {
                    this.tianjiaziyuan.data = this.ziyuanliebiao[i].data
                    this.tianjiaziyuan.id = this.ziyuanliebiao[i].id
                }
            }
        },
        remoteMethod(query) {
            // console.log('isme',query);
            let data = {
                token: this.$store.state.authority_management,
                offset: 0,
                length: 99,
                type: this.typeid,
                name: query
            }
            this.$post('resources/shop_search', data).then(res => {
                // console.log(res.data.result.data)
                this.ziyuanliebiao = res.data.result.data
            })

        },

        ResetErrorMessage() {
            setTimeout((res) => {
                this.errortext = ''
                this.style = 'display:none'
            }, 5000)
        },
        addresource(){
            // console.log(this.ziyuan)
            if(this.ziyuan.length >=1){
                this.$message({
                    type: 'warning ',
                    message: '每小节资源只能有一个!'
                });
            }
            // return false
            else this.tianjiajieziyuan = true
        },
        tianjiajzy() {
            if (this.tianjiaziyuan.type == '') {
                this.style = 'display:block'
                this.errortext = '请选择资源类型'
                this.ResetErrorMessage();
                return;
            }
            if (this.tianjiaziyuan.get == '') {
                this.style = 'display:block'
                this.errortext = '请选择资源文件'
                this.ResetErrorMessage();
                return;
            }

            // console.log(this.tianjiaziyuan)
            // console.log(this.ziyuan)
            let ziyuan = this.ziyuan
            ziyuan.push({
                data: this.tianjiaziyuan.data,
                name: this.tianjiaziyuan.get,
                type: this.tianjiaziyuan.type
            })
            this.ziyuan = ziyuan

            let itemname = this.itemname
            let arr = this.data
            let brr = []
            for (let i = 0; i < arr.length; i++) {
                for (let j = 0; j < arr[i].children.length; j++) {
                    if (arr[i].children[j].label == itemname) {
                        // console.log(arr[i].children[j].resources[this.ziyuanindex])
                        arr[i].children[j].resources.push(this.tianjiaziyuan.id)
                        arr[i].children[j].type = this.tianjiaziyuan.type
                    }
                }
            }

            let resources = []
            for (let val of arr) {
                let items = []
                for (let i = 0; i < val.children.length; i++) {
                    items.push({
                        name: val.children[i].label,
                        resources: val.children[i].resources,
                        type : this.typechule(val.children[i].type)
                    })
                }
                resources.push({
                    name: val.label,
                    items: items
                })
            }
            // console.log(resources)
            // console.log(this.arr.id)

            let date = {
                token: this.$store.state.authority_management,
                resources: JSON.stringify(resources),
                id: this.arr.id
            }

            this.$post('activities/shop_edit', date).then(res => {
                // console.log(res)
                this.$message({
                    type: 'success',
                    message: '添加资源成功!'
                });
                // this.ziyuan[this.ziyuanindex] = this.jieziyuan                  
                this.style = 'display:none'
                this.tianjiaziyuan = {
                    type: '',
                    name: '',
                    get: '',
                    data: '',
                    id: ''
                }
                this.tianjiajieziyuan = false
            })
        },
        // 类型处理
        typechule(str){
            if(str == "视频"){
                return 1
            }else if(str == "习题"){
                return 2
            }else if(str == "音频"){
                return 3
            }else if(str == "文件"){
                return 4
            }else if(str == "图片"){
                return 5
            }else if(str == "讨论区"){
                return 6
            }else if(str == "课后习题"){
                return 7
            }else{
                return 0
            }
        },
        //关闭添加资源表单事件
        closetianjiajieziyuan(){
            this.ziyuanliebiao = [];
        },
        xiugaij() {
            if (this.jieziyuan.type == '') {
                this.style = 'display:block'
                this.errortext = '请选择资源类型'
                this.ResetErrorMessage();
                return;
            }
            if (this.jieziyuan.get == '') {
                this.style = 'display:block'
                this.errortext = '请选择资源文件'
                this.ResetErrorMessage();
                return;
            }

            let itemname = this.itemname
            let arr = this.data
            let brr = []
            for (let i = 0; i < arr.length; i++) {
                for (let j = 0; j < arr[i].children.length; j++) {
                    if (arr[i].children[j].label == itemname) {
                        // console.log(arr[i].children[j].resources[this.ziyuanindex])
                        arr[i].children[j].resources[this.ziyuanindex] = this.jieziyuan.id
                    }
                }
            }

            let resources = []
            for (let val of arr) {
                let items = []
                for (let i = 0; i < val.children.length; i++) {
                    items.push({
                        name: val.children[i].label,
                        resources: val.children[i].resources,
                        type : this.typechule(val.children[i].type)
                    })
                }
                resources.push({
                    name: val.label,
                    items: items
                })
            }
            // console.log(resources)
            // console.log(this.arr.id)

            let date = {
                token: this.$store.state.authority_management,
                resources: JSON.stringify(resources),
                id: this.arr.id
            }

            this.$post('activities/shop_edit', date).then(res => {
                // console.log(res)
                this.$message({
                    type: 'success',
                    message: '修改成功!'
                });
                this.ziyuan[this.ziyuanindex] = this.jieziyuan
                this.style = 'display:none'
                this.jieziyuan = {
                    type: '',
                    name: '',
                    get: '',
                    data: '',
                    id: ''
                }
                this.xiugaijieziyuan = false
            })


            // console.log(this.jieziyuan)
            // console.log(this.ziyuan[this.ziyuanindex])
        },

        handleNodeClick(item) {
            // console.log(item)
            this.itemname = item.label
            this.ziyuan = []
            if (item.resources == undefined) {
                this.liebiao = 'display:none'
                this.empty = 'display:block'
            } else {
                this.liebiao = 'display:block'
                this.empty = 'display:none'
                for (let i = 0; i < item.resources.length; i++) {
                    let data = {
                        token: this.$store.state.authority_management,
                        id: item.resources[i]
                    }
                    this.$post('resources/get', data).then(res => {
                        // console.log(res.data.result)                      
                        let arr = this.ziyuan
                        arr.push(res.data.result)
                        if (arr[i].type == 2) {
                            arr[i].data = '无'
                        }
                        arr[i].type = this.type[arr[i].type - 1]
                        this.ziyuan = arr
                    })
                }
                // console.log(this.ziyuan)
            }
        },
        confirmChange(){
            this.upname = false;
            let node = this.nodeFlag;
            let data = this.dataFlag; 

            // console.log('--------------------')
            // console.log(node,data)
            // console.log(this.data)
            const parent = node.parent;
            const children = parent.data.children || parent.data;
            let index = children.findIndex(d => d.label == data.label);
            // console.log(index)
            // return false
            // console.log(parent,children,index)
            index = parseInt(index)
            children[index].label = this.nodeName
            // console.log(children[index])
            // return false
            // console.log(children)
            let brr = {label:'',items:[]};
            brr.label = parent.label;
            brr.items = children
            // console.log(children)
            // console.log(parent)
            let arr = this.data
            //  console.log('arr',arr)
            // console.log(arr)
            const index2 = arr.findIndex(a => a.label == parent.label)
            // console.log(index2)
            if(index2 != -1){
                arr[index2] = brr;
            }
            arr = JSON.parse(JSON.stringify(arr).replace(/children/g, 'items'))
            arr = JSON.parse(JSON.stringify(arr).replace(/label/g, 'name'))
            // console.log('最后的数据')
            // console.log(JSON.stringify(arr).replace(/children/g, 'items'))
            // console.log(arr)
            // console.log(JSON.stringify(arr))
            // return false
            let date = {
                token: this.$store.state.authority_management,
                resources: JSON.stringify(arr),
                id: this.arr.id
            }
            this.$post('activities/shop_edit', date).then(res => {
                this.$message({
                    type: 'success',
                    message: '修改成功!'
                });
                // console.log(res)
                this.nodeName = null;
            })

        },
        updata(node,data){
            this.upname = true;
            this.nodeFlag = node;
            this.dataFlag = data;
            const parent = node.parent;
            const children = parent.data.children || parent.data;
            let index = children.findIndex(d => d.label == data.label);
            this.oldNodeName = children[index].label
            return false
          
        },
        //删除节点
        remove(node, data) {
            // console.log('--------------------')
            // console.log(node,data)
            // console.log(this.data)
            const parent = node.parent;
            const children = parent.data.children || parent.data;
            // console.log(parent.label)
            // console.log(parent.childNodes[0].data)
            // console.log(children)
            const index = children.findIndex(d => d.label == data.label);
            // console.log(index)
            // return false
            // console.log(parent,children,index)
            children.splice(index, 1);
            // console.log(children)
            let brr = {label:'',items:[]};
            brr.label = parent.label;
            brr.items = children
            // console.log(children)
            // console.log(parent)
            let arr = this.data
            // console.log('arr')
            // console.log(arr)
            const index2 = arr.findIndex(a => a.label == parent.label)
            // console.log(index2)
            if(index2 != -1){
                arr[index2] = brr;
            }

            arr = JSON.parse(JSON.stringify(arr).replace(/children/g, 'items'))
            arr = JSON.parse(JSON.stringify(arr).replace(/label/g, 'name'))

            // console.log('最后的数据')
            // console.log(JSON.stringify(arr).replace(/children/g, 'items'))
            // console.log(arr)
            // console.log(JSON.stringify(arr))
            // return false
            let date = {
                token: this.$store.state.authority_management,
                resources: JSON.stringify(arr),
                id: this.arr.id
            }

            this.$post('activities/shop_edit', date).then(res => {
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
                // console.log(res)
            })
          },
        tianjiaj() {
            if (this.jie.name == '') {
                this.style = 'display:block'
                this.errortext = '名称必须填写'
                this.ResetErrorMessage();
                return;
            }
            if (this.jie.region == '') {
                this.style = 'display:block'
                this.errortext = '请选择添加节的位置'
                this.ResetErrorMessage();
                return;
            }
            let arr = []

            for (let val of this.data) {
                arr.push(val.label)
            }
            let i = arr.indexOf(this.jie.region)
            // console.log(this.data)
            let brr = this.data
            // console.log(this.data[i].children)
            brr[i].children.push({
                label: this.jie.name,
                resources: []
            })

            let resources = []
            for (let val of brr) {
                let items = []
                for (let i = 0; i < val.children.length; i++) {
                    items.push({
                        name: val.children[i].label,
                        resources: val.children[i].resources
                    })
                }
                resources.push({
                    name: val.label,
                    items: items
                })
            }
            // console.log('最后的数组')
            // console.log(resources)
            let date = {
                token: this.$store.state.authority_management,
                resources: JSON.stringify(resources),
                id: this.arr.id
            }

            this.$post('activities/shop_edit', date).then(res => {
                this.$message({
                    type: 'success',
                    message: '添加节成功!'
                });
                // console.log(res)
            })


            this.data = brr
            this.style = 'display:none'
            this.jie = {
                name: '',
                region: ''
            }
            this.tianjiajie = false
        },

        tianjiaz() {
            if (this.zhang.name == '') {
                this.style = 'display:block'
                this.errortext = '名称必须填写'
                this.ResetErrorMessage();
                return;
            }
            if (this.zhang.region == '') {
                this.style = 'display:block'
                this.errortext = '请选择添加章的位置'
                this.ResetErrorMessage();
                return;
            }
            let arr = []
            let brr = this.data
            for (let val of this.data) {
                arr.push(val.label)
            }
            let i = arr.indexOf(this.zhang.region)
            if (i == -1) {
                brr.splice(0, 0, {
                    label: this.zhang.name,
                    children: []
                })
                this.data = brr
                this.style = 'display:none'
                this.zhang = {
                    name: '',
                    region: ''
                }
                this.tianjiazhang = false
            } else {
                brr.splice(i + 1, 0, {
                    label: this.zhang.name,
                    children: []
                })
                this.data = brr
                this.style = 'display:none'
                this.zhang = {
                    name: '',
                    region: ''
                }
                this.tianjiazhang = false
            }

            let resources = []
            for (let val of brr) {
                let items = []
                for (let i = 0; i < val.children.length; i++) {
                    items.push({
                        name: val.children[i].label,
                        resources: val.children[i].resources
                    })
                }
                resources.push({
                    name: val.label,
                    items: items
                })
            }

            let date = {
                token: this.$store.state.authority_management,
                resources: JSON.stringify(resources),
                id: this.arr.id
            }

            this.$post('activities/shop_edit', date).then(res => {
                this.$message({
                    type: 'success',
                    message: '添加章成功!'
                });
                // console.log(res)
            })

        },

        handleClick(num, index) {
            // console.log('修改传值',num)
            this.arr = this.tableData[index]
            this.huodongtype = this.arr.icon_type
            this.resources = JSON.parse(this.arr.resources)
            // console.log(this.resources)
            let brr = []
            for (let val of this.resources) {
                let children = []
                // console.log(val.items.length )
                // console.log('-------')
                // return false
                for (let i = 0; i < val.items.length; i++) {
                    children.push({
                        label: val.items[i].name,
                        resources: val.items[i].resources
                    })
                }
                brr.push({
                    label: val.name,
                    children: children
                })
            }
            // return false
            this.data = brr
            // console.log(brr)
            if (num == 1) {
                this.show2 = 'display:block',
                    this.show1 = 'display:none'
            }
            if (num == 2) {
                this.dialogFormVisibles = true
            }
            if (num == 3) {
                this.$confirm('此操作将删除该活动, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let data = {
                        id: this.arr.id,
                        token: this.$store.state.authority_management
                    }
                    this.$post('activities/delete', data).then(res => {
                        // console.log(res)
                        this.getactivities();
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                    })

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            }
        },
        //获取活动类型
        QueryActivityType(){
            this.$post('icon_type/search', {
                offset:0,
                length:9999,
                token: this.$store.state.authority_management,
            
            }).then(res => {
                this.huodongtypes = res.data.result
                // console.log('this.huodongtypes',this.huodongtypes)

            })
        },
       
        tinajiahuod() {
            if (this.form.name == '') {
                this.$message({
                    showClose: true,
                    message: '活动名称不能为空',
                    type: 'error'
                });
                this.ResetErrorMessage();
                return;
            }
            // if (!this.huodongtype) {
            //     this.$message({
            //         showClose: true,
            //         message: '活动类型不能为空',
            //         type: 'error'
            //     });
            //     this.ResetErrorMessage();
            //     return;
            // }
            if (this.form.region == '') {
                this.$message({
                    showClose: true,
                    message: '活动描述不能为空',
                    type: 'error'
                });
                this.ResetErrorMessage();
                return;
            } else {
                this.create();
                this.style = 'display:none'
                this.form.name = ''
                this.form.region = ''
                this.dialogFormVisible = false
            }
        },
        xiugaihuod() {
            
            if (this.arr.name == '') {
                this.$message({
                    showClose: true,
                    message: '活动名称不能为空',
                    type: 'error'
                });
                // this.errortext = '活动名称不能为空'
                // this.style = 'display:block'
                this.ResetErrorMessage();
                return;
            }
            // if (!this.huodongtype) {
            //     this.$message({
            //         showClose: true,
            //         message: '活动类型不能为空',
            //         type: 'error'
            //     });
            //     this.ResetErrorMessage();
            //     return;
            // }
            if (this.arr.desc == '') {
                this.$message({
                    showClose: true,
                    message: '活动描述不能为空',
                    type: 'error'
                });
                // this.errortext = '活动描述不能为空'
                // this.style = 'display:block'
                this.ResetErrorMessage();
                return;
            } else {
                let data = {
                    shop_id: this.arr.shop_id,
                    name: this.arr.name,
                    icon_type_id: this.huodongtype,
                    desc: this.arr.desc,
                    resources: this.arr.resources,
                    type:this.typechule(this.arr.type),
                    id: this.arr.id,
                    sort: 1,
                    token: this.$store.state.authority_management,
                }
                this.$post('activities/edit', data).then(res => {
                    // console.log(res)
                    this.$message({
                        type: 'success',
                        message: '修改成功!'
                    });
                    this.style = 'display:none'
                    this.huodongtype = ""
                    this.dialogFormVisibles = false
                    this.getactivities();
                  
                })

            }
        },

        getactivities() {
            let name = this.activitieSearchName
            let data = {
                token: this.$store.state.authority_management,
                offset: this.offset,
                length: this.length,
                shop_id: this.$store.state.store.id,
                name: name,
            }
            this.$post('activities/search', data).then(res => {
                // console.log(res)
                this.tableData = res.data.result.data
                this.total = res.data.result.total
            })
        },

        //根据名称搜索活动
        confirmSearch() {
            this.currentPage = 1
            let name = this.activitieSearchName
            let data = {
                token: this.$store.state.authority_management,
                offset: 0,
                length: this.length,
                name: name,
                shop_id: this.$store.state.store.id
            }
            this.$post('activities/search', data).then(res => {
                // console.log(res)
                this.tableData = res.data.result.data
                this.total = res.data.result.total
            })
        },
        //添加活动
        create() {
            let data = {
                name: this.form.name,
                desc: this.form.region,
                resources: JSON.stringify(([

                ])),
                token: this.$store.state.authority_management,
            }

            this.$post('activities/create', data).then(res => {
                // console.log(res)
                this.$message({
                    type: 'success',
                    message: '添加活动成功!'
                });
                this.getactivities();
                this.huodongtype=""
            })
        }
    },

    created() {
        this.QueryActivityType()
        this.getactivities();
    },

    data() {
        return {
            // 活动类型集合
            huodongtypes:[],
            // 活动类型
            huodongtype:'',
            //当前页数
            currentPage: 1,
            //搜索活动的名字
            activitieSearchName: '',
            loading: false,
            offset: 0,
            length: 15,
            ziyuanindex: '',
            itemname: '',
            typeid: '',
            total: 0,
            arr: '',
            data: [],
            defaultProps: {
                children: 'children',
                label: 'label'
            },
            tableData: [],
            ziyuan: [],
            ziyuanliebiao: [],
            type: ['视频', '习题', '音频', '文件', '图片','讨论区','课后习题'],
            dialogFormVisible: false,
            dialogFormVisibles: false,
            xiugaijieziyuan: false,
            tianjiajieziyuan: false,
            tianjiazhang: false,
            tianjiajie: false,
            upname:false,
            liebiao: 'display:none',
            empty: 'display:block',
            show1: 'display:block',
            show2: 'display:none',
            style: 'display:none',
            errortext: '',
            form: {
                name: '',
                region: '',
            },
            zhang: {
                name: '',
                region: '',
            },
            jie: {
                name: '',
                region: '',
            },
            jieziyuan: {
                type: '',
                name: '',
                get: '',
                data: '',
                id: ''
            },
            tianjiaziyuan: {
                type: '',
                name: '',
                get: '',
                data: '',
                id: ''
            },
            formLabelWidth: '120px',
            nodeName:'',
            nodeFlag:null,
            dataFlag:null,
            oldNodeName:null,
        }
    }

}